export default __webpack_public_path__ + "static/media/gasag_l1.67630cb7.png";